<template>
  <div class="pk-contract-page pk-account-panel">
    <section class="pk-contract-head">
      <div>
        <span>合约</span>
        <h1>披萨合约</h1>
        <p>选择 3 - 10 件饰品组成合约。</p>
      </div>
      <div class="pk-contract-head-actions">
        <button @click="openPanel('history')">我的历史</button>
        <button @click="showRules">&#22914;&#20309;&#36816;&#20316;</button>
      </div>
    </section>

    <section class="pk-contract-board">
      <aside class="pk-contract-inventory">
        <div class="pk-contract-panel-head">
          <strong>库存</strong>
          <span>{{ inventory.length }} 件</span>
        </div>
        <div class="pk-contract-toolbar">
          <button v-for="filter in inventoryFilters" :key="filter.key" :class="{ active: inventoryFilter === filter.key }" @click="inventoryFilter = filter.key">
            {{ filter.label }}
          </button>
        </div>
        <div v-if="!loggedIn" class="pk-contract-empty">
          <strong>登录后查看库存</strong>
          <span>合约只读取当前账号可用饰品，访客状态不会展示模拟资产。</span>
          <button @click="openLogin">登录 / 注册</button>
        </div>
        <div v-else-if="loading" class="pk-contract-empty">
          <strong>正在读取库存</strong>
        </div>
        <div v-else-if="filteredInventory.length" class="pk-contract-items">
          <article v-for="item in filteredInventory" :key="item.name" :class="{ active: selectedNames.includes(item.name) }" class="pk-contract-item" @click="toggleItem(item)">
            <img :src="item.img" :alt="item.name" />
            <strong>{{ item.name }}</strong>
            <span>{{ item.price }}</span>
          </article>
        </div>
        <div v-else class="pk-contract-empty">
          <strong>暂无可用于合约的饰品</strong>
          <span>打开箱子或箱子战斗获得可用饰品后，会显示在这里。</span>
        </div>
      </aside>

      <main class="pk-contract-builder">
        <div class="pk-contract-builder-head">
          <div>
            <span>合约</span>
            <strong>{{ contractMode === 'crazy' ? '疯狂模式' : '经典模式' }}</strong>
          </div>
          <div class="pk-contract-modes">
            <button :class="{ active: contractMode === 'crazy' }" @click="contractMode = 'crazy'">Crazy Mode</button>
            <button :class="{ active: contractMode === 'normal' }" @click="contractMode = 'normal'">Classic Mode</button>
          </div>
        </div>

        <p class="pk-contract-mode-copy">
          {{ contractMode === 'crazy' ? '在疯狂模式中选择 3 - 10 件饰品，并选择低、中或高风险。' : '在经典模式中选择符合品质要求的饰品，完成后可在本页查看结果。' }}
        </p>

        <div v-if="contractMode === 'crazy'" class="pk-contract-risk">
          <span>风险</span>
          <button v-for="item in risks" :key="item.key" :class="[item.key, { active: risk === item.key }]" @click="risk = item.key">
            <i></i>{{ item.label }}
          </button>
        </div>

        <div class="pk-contract-slots">
          <button v-for="slot in 10" :key="slot" :class="{ filled: slot <= selectedItems.length }">
            <img v-if="selectedItems[slot - 1]" :src="selectedItems[slot - 1].img" :alt="selectedItems[slot - 1].name" />
            <span v-else>+</span>
          </button>
        </div>

        <div class="pk-contract-core">
          <div class="pk-contract-ring">
            <img src="../assets/pizzaking/icon-contract.svg" alt="contract" />
          </div>
          <div class="pk-contract-copy">
            <span>已将 {{ selectedItems.length }} 件价值 {{ selectedPrice }} 的物品加入合约</span>
            <strong>{{ selectedItems.length ? '确认饰品后创建合约' : '从左侧库存选择饰品' }}</strong>
            <p>选择饰品后可查看投入价值。</p>
          </div>
        </div>

        <div class="pk-contract-actions">
          <button class="ghost" @click="clearItems">&#28165;&#31354;</button>
          <button class="primary" @click="notifyUnavailable">&#21019;&#24314;&#21512;&#32422;</button>
        </div>
      </main>

    </section>

    <section class="pk-contract-rules">
      <header>
        <span>披萨合约</span>
        <h2>合约如何运作？</h2>
      </header>
      <div class="pk-contract-rule-grid">
        <article>
          <b>1</b>
          <strong>选择饰品</strong>
          <span>疯狂模式选择 3 - 10 件饰品；经典模式按品质要求选择饰品。</span>
        </article>
        <article>
          <b>2</b>
          <strong>选择模式与风险</strong>
          <span>疯狂模式可切换低、中、高风险；经典模式不显示风险档位。</span>
        </article>
        <article>
          <b>3</b>
          <strong>获得结果</strong>
          <span>确认合约后查看结果。</span>
        </article>
      </div>
      <div class="pk-contract-explain">
        <p><strong>什么是 Pizza Contracts？</strong> 将饰品组合为一份合约，并在完成后查看对应结果。</p>
        <p><strong>疯狂模式：</strong>可选择 3 - 10 件饰品并调整风险。</p>
        <p><strong>经典模式：</strong>根据放入饰品的品质和系列匹配结果。</p>
      </div>
    </section>

    <div v-if="panel" class="pk-contract-modal" @click.self="closePanel">
      <section class="pk-contract-modal-card">
        <button class="pk-contract-modal-close" @click="closePanel">×</button>
        <template v-if="panel === 'history'">
          <span>我的历史</span>
          <h2>合约记录</h2>
          <template v-if="history.length">
            <div class="pk-contract-history-row" v-for="item in history" :key="item.id">
              <strong>{{ item.id }}</strong><span>{{ item.status }}</span><b>{{ item.value }}</b>
            </div>
          </template>
          <p v-else class="pk-contract-history-empty">暂无已结算合约记录</p>
        </template>
        <template v-else>
          <span>玩法介绍</span>
          <h2>{{ contractMode === 'normal' ? '常规合约' : '疯狂合约' }}</h2>
          <p>选择至多 10 件饰品查看投入价值与结果区。</p>
        </template>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "Contracts",
  data() {
    return {
      inventory: [],
      inventoryFilters: [
        { key: "all", label: "所有物品" },
        { key: "mil-spec", label: "Mil-Spec" },
        { key: "restricted", label: "Restricted" },
        { key: "classified", label: "Classified" },
        { key: "covert", label: "Covert" },
      ],
      risks: [
        { key: "low", label: "低" },
        { key: "medium", label: "中" },
        { key: "high", label: "高" },
      ],
      selectedNames: [],
      contractMode: "crazy",
      inventoryFilter: "all",
      risk: "low",
      loading: false,
      panel: "",
      history: [],
    };
  },
  computed: {
    loggedIn() {
      return Boolean(this.$store.state.token || localStorage.getItem("token"));
    },
    selectedItems() {
      return this.inventory.filter((item) => this.selectedNames.includes(item.name));
    },
    selectedPrice() {
      return this.selectedItems.reduce((total, item) => total + Number(item.price), 0).toFixed(2);
    },
    filteredInventory() {
      if (this.inventoryFilter !== "all") {
        return this.inventory.filter((item) => item.rarity === this.inventoryFilter);
      }
      return this.inventory;
    },
  },
  mounted() {
    if (this.loggedIn) this.loadInventory();
  },
  methods: {
    openLogin() {
      this.$store.commit("getLogin", true);
    },
    loadInventory() {
      this.loading = true;
      this.$axios.post("/index/User/packageListnew", this.$qs.stringify({
        page: 1,
        pageSize: 40,
        status_filter: "available",
      })).then((res) => {
        const payload = res.data && res.data.status == 1 ? res.data.data : null;
        const list = payload && Array.isArray(payload.skinList) ? payload.skinList : [];
        this.inventory = list.filter((item) => item.can_exchange == 1).map((item) => ({
          id: item.id,
          name: item.name,
          price: Number(item.price || 0).toFixed(2),
          img: item.img,
          rarity: String(item.rarity_name || item.quality_name || "").toLowerCase().replace(/\s+/g, "-"),
        }));
      }).finally(() => {
        this.loading = false;
      });
    },
    toggleItem(item) {
      if (this.selectedNames.includes(item.name)) {
        this.selectedNames = this.selectedNames.filter((name) => name !== item.name);
        return;
      }
      if (this.selectedNames.length < 10) {
        this.selectedNames.push(item.name);
      }
    },
    clearItems() {
      this.selectedNames = [];
    },
    openPanel(panel) {
      this.panel = panel;
    },
    closePanel() {
      this.panel = "";
    },
    notifyUnavailable() {
      this.$message({
        message: "合约暂未开放。",
        type: "info",
      });
    },
    showRules() {
      this.openPanel("rules");
    },
  },
};
</script>

<style lang="less" scoped>
.pk-contract-page {
  min-height: calc(100vh - 199px);
  padding: 18px 24px 96px;
  color: #f4f6ff;
  background:
    radial-gradient(ellipse at 50% 220px, rgba(255, 208, 102, 0.08), transparent 460px),
    #191b26;
}

.pk-contract-head,
.pk-contract-board,
.pk-contract-rules {
  width: 100%;
}

.pk-contract-head {
  min-height: 82px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background:
    radial-gradient(ellipse at 16% 50%, rgba(255, 208, 102, 0.12), transparent 340px),
    #20222f;
}

.pk-contract-head span,
.pk-contract-panel-head span {
  color: #ffbd42;
  font-size: 12px;
  font-weight: 900;
}

.pk-contract-head h1 {
  margin: 4px 0 6px;
  color: #fff7df;
  font-size: 26px;
  line-height: 30px;
}

.pk-contract-head p {
  margin: 0;
  color: #8f98ab;
  font-size: 13px;
}

.pk-contract-head button,
.pk-contract-actions button {
  height: 42px;
  padding: 0 22px;
  color: #ecd8b8;
  border: 1px solid rgba(236, 216, 184, 0.42);
  border-radius: 7px;
  background: transparent;
  font-weight: 900;
}

.pk-contract-head-actions,
.pk-contract-modes {
  display: flex;
  align-items: center;
}

.pk-contract-head-actions {
  gap: 10px;
}

.pk-contract-modes button {
  min-width: 58px;
  height: 34px;
  padding: 0 12px;
  color: #b8c0cf;
  border: 1px solid #3b4052;
  background: #252837;
  font-size: 12px;
}

.pk-contract-modes button + button {
  margin-left: -1px;
}

.pk-contract-modes button.active {
  position: relative;
  z-index: 1;
  color: #fff3d6;
  border-color: rgba(255, 189, 66, 0.7);
  background: #343746;
}

.pk-contract-board {
  min-height: 640px;
  margin-top: 8px;
  display: grid;
  grid-template-columns: minmax(360px, 0.78fr) minmax(620px, 1.62fr);
  gap: 8px;
}

.pk-contract-inventory,
.pk-contract-builder,
.pk-contract-result,
.pk-contract-rules article {
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background: #20222f;
}

.pk-contract-panel-head {
  height: 58px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #2b2d3c;
}

.pk-contract-panel-head strong {
  color: #f4ead8;
  font-size: 16px;
}

.pk-contract-toolbar {
  padding: 12px;
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 5px;
}

.pk-contract-toolbar button {
  height: 36px;
  padding: 0 4px;
  color: #8f98ab;
  border: 1px solid #303443;
  border-radius: 6px;
  background: #252837;
  font-size: 11px;
}

.pk-contract-empty {
  min-height: 480px;
  padding: 40px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background:
    radial-gradient(circle at 50% 44%, rgba(255, 189, 66, 0.08), transparent 170px),
    #20222f;
}

.pk-contract-empty strong {
  color: #f4ead8;
  font-size: 18px;
}

.pk-contract-empty span {
  max-width: 300px;
  margin-top: 10px;
  color: #8f98ab;
  font-size: 13px;
  line-height: 21px;
}

.pk-contract-empty button {
  height: 40px;
  margin-top: 20px;
  padding: 0 22px;
  color: #fff7df;
  border: 0;
  border-radius: 6px;
  background: linear-gradient(180deg, #ff971f, #f26b00);
  font-weight: 900;
}

.pk-contract-toolbar button.active {
  color: #fff7df;
  border-color: rgba(255, 189, 66, 0.42);
}

.pk-contract-items {
  padding: 0 12px 12px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.pk-contract-item {
  min-height: 154px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background:
    radial-gradient(circle at 50% 38%, rgba(255, 208, 102, 0.12), transparent 48%),
    #252837;
}

.pk-contract-item.active {
  border-color: rgba(255, 189, 66, 0.72);
  box-shadow: inset 0 0 0 1px rgba(255, 189, 66, 0.22), 0 0 20px rgba(255, 139, 29, 0.12);
}

.pk-contract-item img {
  max-width: 132px;
  max-height: 82px;
  object-fit: contain;
  filter: drop-shadow(0 14px 16px rgba(0, 0, 0, 0.38));
}

.pk-contract-item strong,
.pk-contract-prize strong {
  margin-top: 10px;
  color: #f5f7ff;
  font-size: 12px;
  text-align: center;
}

.pk-contract-item span,
.pk-contract-prize span {
  margin-top: 7px;
  color: #ffbd42;
  font-size: 14px;
  font-weight: 900;
}

.pk-contract-builder {
  padding: 22px;
  display: grid;
  grid-template-rows: auto auto auto auto 1fr auto;
  align-content: start;
  overflow: hidden;
  background:
    radial-gradient(ellipse at 50% 42%, rgba(255, 208, 102, 0.12), transparent 360px),
    #20222f;
}

.pk-contract-builder-head {
  min-height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.pk-contract-builder-head > div:first-child span,
.pk-contract-builder-head > div:first-child strong {
  display: block;
}

.pk-contract-builder-head > div:first-child span {
  color: #ffbd42;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.12em;
}

.pk-contract-builder-head > div:first-child strong {
  margin-top: 5px;
  color: #fff7df;
  font-size: 21px;
}

.pk-contract-mode-copy {
  margin: 8px 0 14px;
  padding: 13px 16px;
  color: #a8b0c0;
  border-left: 2px solid #ffbd42;
  background: rgba(37, 40, 55, 0.72);
  font-size: 13px;
}

.pk-contract-risk {
  min-height: 64px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-top: 1px solid #2b2d3c;
  border-bottom: 1px solid #2b2d3c;
}

.pk-contract-risk > span {
  margin-right: 8px;
  color: #8f98ab;
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
}

.pk-contract-risk button {
  min-width: 92px;
  height: 34px;
  color: #8f98ab;
  border: 1px solid #363a49;
  border-radius: 18px;
  background: #252837;
  font-weight: 900;
}

.pk-contract-risk button i {
  width: 8px;
  height: 8px;
  margin-right: 8px;
  display: inline-block;
  border-radius: 50%;
  background: #5f6678;
}

.pk-contract-risk button.low i { background: #59dc91; box-shadow: 0 0 12px rgba(89, 220, 145, 0.72); }
.pk-contract-risk button.medium i { background: #ffbd42; box-shadow: 0 0 12px rgba(255, 189, 66, 0.72); }
.pk-contract-risk button.high i { background: #ef5c6c; box-shadow: 0 0 12px rgba(239, 92, 108, 0.72); }
.pk-contract-risk button.active { color: #fff7df; border-color: rgba(255, 189, 66, 0.72); }

.pk-contract-slots {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.pk-contract-slots button {
  height: 86px;
  display: grid;
  place-items: center;
  color: #6f788c;
  border: 1px dashed rgba(236, 216, 184, 0.26);
  border-radius: 7px;
  background: rgba(28, 29, 41, 0.74);
}

.pk-contract-slots button.filled {
  border-style: solid;
  border-color: rgba(255, 189, 66, 0.32);
  background:
    radial-gradient(circle at 50% 44%, rgba(255, 208, 102, 0.11), transparent 58%),
    #252837;
}

.pk-contract-slots img {
  max-width: 92px;
  max-height: 64px;
  object-fit: contain;
}

.pk-contract-core {
  display: grid;
  place-items: center;
  text-align: center;
}

.pk-contract-ring {
  width: 146px;
  height: 146px;
  display: grid;
  place-items: center;
  border: 1px solid rgba(255, 208, 102, 0.25);
  border-radius: 50%;
  background:
    radial-gradient(circle, rgba(255, 208, 102, 0.18), transparent 58%),
    #1c1d29;
  box-shadow: 0 0 44px rgba(255, 208, 102, 0.08);
}

.pk-contract-ring img {
  width: 74px;
  height: 74px;
}

.pk-contract-copy span {
  display: block;
  margin-top: 18px;
  color: #ffbd42;
  font-weight: 900;
}

.pk-contract-copy strong {
  display: block;
  margin-top: 8px;
  color: #fff7df;
  font-size: 22px;
}

.pk-contract-copy p {
  max-width: 440px;
  margin: 10px auto 0;
  color: #8f98ab;
  font-size: 13px;
  line-height: 22px;
}

.pk-contract-actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}

.pk-contract-actions .primary {
  color: #fff7df;
  border-color: rgba(255, 214, 128, 0.35);
  background: linear-gradient(180deg, #ff971f, #f26b00);
}

.pk-contract-result {
  overflow: hidden;
}

.pk-contract-prize {
  min-height: 270px;
  margin: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px solid #303443;
  border-radius: 7px;
  background:
    radial-gradient(circle at 50% 44%, rgba(42, 255, 155, 0.16), transparent 52%),
    #252837;
}

.pk-contract-prize img {
  max-width: 220px;
  max-height: 150px;
  object-fit: contain;
  filter:
    drop-shadow(0 24px 24px rgba(0, 0, 0, 0.45))
    drop-shadow(0 0 28px rgba(42, 255, 155, 0.14));
}

.pk-contract-summary {
  padding: 0 12px 12px;
}

.pk-contract-summary p {
  height: 42px;
  margin: 0 0 8px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #8f98ab;
  border-radius: 6px;
  background: #252837;
}

.pk-contract-summary b {
  color: #ffbd42;
}

.pk-contract-rules {
  margin-top: 8px;
  padding: 26px;
  border: 1px solid #2b2d3c;
  border-radius: 8px;
  background: #20222f;
}

.pk-contract-rules header span {
  color: #ffbd42;
  font-size: 11px;
  font-weight: 900;
  letter-spacing: 0.12em;
}

.pk-contract-rules header h2 {
  margin: 7px 0 20px;
  color: #fff7df;
  font-size: 24px;
}

.pk-contract-rule-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.pk-contract-rules article {
  min-height: 92px;
  padding: 18px;
  display: grid;
  grid-template-columns: 36px 1fr;
  column-gap: 12px;
}

.pk-contract-explain {
  margin-top: 12px;
  padding: 18px 20px;
  color: #8f98ab;
  border: 1px solid #2b2d3c;
  border-radius: 7px;
  background: #1c1e29;
  font-size: 13px;
  line-height: 22px;
}

.pk-contract-explain p {
  margin: 0;
}

.pk-contract-explain p + p {
  margin-top: 8px;
}

.pk-contract-explain strong {
  color: #f4ead8;
}

.pk-contract-rules b {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  color: #11131d;
  border-radius: 50%;
  background: #ffbd42;
}

.pk-contract-rules strong {
  color: #fff7df;
}

.pk-contract-rules span {
  grid-column: 2;
  color: #8f98ab;
  font-size: 13px;
}

.pk-contract-modal {
  position: fixed;
  z-index: 80;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(11, 12, 18, 0.76);
}

.pk-contract-modal-card {
  width: 470px;
  max-width: 100%;
  position: relative;
  padding: 30px;
  color: #f7f1e4;
  background: radial-gradient(circle at 50% 0, rgba(255, 189, 66, 0.14), transparent 48%), #242735;
  border: 1px solid rgba(238, 216, 181, 0.28);
  border-radius: 9px;
  box-shadow: 0 24px 80px rgba(0, 0, 0, 0.46);
}

.pk-contract-modal-card > span { color: #ffbd42; font-size: 12px; font-weight: 1000; letter-spacing: 0.1em; }
.pk-contract-modal-card h2 { margin: 8px 0 14px; font-size: 24px; }
.pk-contract-modal-card p { margin: 0; color: #b5becd; font-size: 14px; line-height: 1.8; }

.pk-contract-modal-close {
  width: 34px;
  height: 34px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #f4ead8;
  background: transparent;
  border: 0;
  font-size: 28px;
  line-height: 1;
}

.pk-contract-history-row {
  min-height: 46px;
  padding: 0 12px;
  display: grid;
  grid-template-columns: 1.15fr 1fr 0.45fr;
  align-items: center;
  gap: 8px;
  color: #b5becd;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  font-size: 13px;
}

.pk-contract-history-row strong { color: #fff7df; }
.pk-contract-history-row b { color: #ffbd42; text-align: right; }

.pk-contract-history-empty {
  margin: 24px 0 8px;
  padding: 18px;
  color: #9399ad;
  text-align: center;
  border: 1px dashed rgba(255, 255, 255, 0.12);
  border-radius: 6px;
}

@media (max-width: 1280px) {
  .pk-contract-board,
  .pk-contract-rule-grid {
    grid-template-columns: 1fr;
  }

  .pk-contract-toolbar {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style>
